import { FilterDescription, FilterType } from 'src/components/filters/types';
import { FilterOptionsDiscriminator } from 'src/components/filters/FilterOptionsDiscriminator';
import { FilterBlock } from 'src/components/filters/FilterBlock';
import { FilterLanguageBlock } from 'src/components/filters/FilterLanguageBlock';
import { withSilentErrorBoundary } from 'src/utils/WithSilentErrorBoundary';

export const FilterBlockDiscriminator = withSilentErrorBoundary(
  ({ filter }: { filter: FilterDescription }) => {
    switch (filter.type) {
      case FilterType.SearchInput:
        return <FilterOptionsDiscriminator filter={filter} />;
      case FilterType.Language:
        return <FilterLanguageBlock filter={filter} />;
      default:
        return <FilterBlock filter={filter} />;
    }
  },
);
